module.exports = __webpack_public_path__ + "img/auditing.fe3e019d.png";